/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Show/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaVisibility from 'DesignSystem/Svgs/TysiaVisibility/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Show({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/Password/VisibilityAction/Show"
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaVisibility
  viewPath={`${viewPath}/TysiaVisibility`}
 fill2={dtColorsNeutral900}
/>
{children}
</React.Fragment>)
}